import React, { useState, useEffect } from "react";
import { Routes, Route, useParams, useLocation, Navigate } from "react-router-dom";
import IndexPage from "./pages/IndexPage";
import Menu from "./pages/Menu";
import Wines from "./pages/Wines";
import Vermouth from "./pages/Vermouth";
import Drinks from "./pages/Drinks";
import Header from "./components/Header";
import Error404 from "./pages/Error404";
import translations from "./lib/translations";
import CookiePopup from "./components/CookiePopup";
import CookiesPolicy from "./components/CookiesPolicy";
import "./App.css"


function App () {
  const { lang } = useParams();
  const [selectedLang, setSelectedLang] = useState(lang || 'en');
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState(location.pathname);

  useEffect(() => {
    setSelectedLang(lang || 'es');
  }, [lang]);

  useEffect(() => {
    setCurrentPath(location.pathname);
  }, [location.pathname]);

  function changeLanguage (languageCode) {
    setSelectedLang(languageCode);
    window.history.pushState(null, '', `${currentPath}?lang=${languageCode}`);
  };

  const [restaurantIsActive, setRestaurantIsActive] = useState(false);
  const [gastronomyIsActive, setGastronomyIsActive] = useState(false);
  const [cardIsActive, setCardIsActive] = useState(false);
  const [contactIsActive, setContactIsActive] = useState(false);
  const [gastronomy2IsActive, setGastronomy2IsActive] = useState(false);
  const [card2IsActive, setCard2IsActive] = useState(false);
  const [contact2IsActive, setContact2IsActive] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY || document.documentElement.scrollTop;
      const viewportHeight = window.innerHeight;
    
      setRestaurantIsActive(scrollPosition > 0)
      setGastronomyIsActive(scrollPosition > viewportHeight);
      setCardIsActive(scrollPosition > (viewportHeight * 2));
      setContactIsActive(scrollPosition > (viewportHeight * 3));

      setGastronomy2IsActive(scrollPosition > viewportHeight);
      setCard2IsActive(scrollPosition > (viewportHeight * 2));
      setContact2IsActive(scrollPosition > (viewportHeight * 3));
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      <Header 
      lang={selectedLang} 
      translations={translations} 
      changeLanguage={changeLanguage} 
      gastronomy2IsActive={gastronomy2IsActive} 
      card2IsActive={card2IsActive} 
      contact2IsActive={contact2IsActive}/>
      <Routes>
        <Route exact path="/" element={<IndexPage lang={selectedLang} translations={translations} gastronomyIsActive={gastronomyIsActive} cardIsActive={cardIsActive} contactIsActive={contactIsActive} restaurantIsActive={restaurantIsActive}/>} />
        <Route exact path="/menu" element={<Menu lang={selectedLang} translations={translations} gastronomyIsActive={gastronomyIsActive} cardIsActive={cardIsActive} contactIsActive={contactIsActive} restaurantIsActive={restaurantIsActive}/>} />
        <Route exact path="/wines" element={<Wines lang={selectedLang} translations={translations} gastronomyIsActive={gastronomyIsActive} cardIsActive={cardIsActive} contactIsActive={contactIsActive} restaurantIsActive={restaurantIsActive}/>} />
        <Route exact path="/vermouth" element={<Vermouth lang={selectedLang} translations={translations} gastronomyIsActive={gastronomyIsActive} cardIsActive={cardIsActive} contactIsActive={contactIsActive} restaurantIsActive={restaurantIsActive}/>} />
        <Route exact path="/drinks" element={<Drinks lang={selectedLang} translations={translations} gastronomyIsActive={gastronomyIsActive} cardIsActive={cardIsActive} contactIsActive={contactIsActive} restaurantIsActive={restaurantIsActive}/>} />
        <Route exact path="/politica-de-cookies" element={<CookiesPolicy lang={selectedLang} translations={translations} gastronomyIsActive={gastronomyIsActive} cardIsActive={cardIsActive} contactIsActive={contactIsActive} restaurantIsActive={restaurantIsActive}/>} />
        <Route path="/404" element={<Error404 lang={selectedLang} translations={translations}/>} />
        <Route path="*" element={<Navigate to="/404" replace/>} />
      </Routes>
      <CookiePopup lang={selectedLang} translations={translations}/>
    </div>
  );
}

export default App;